import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging } from '../../actions/log';
import { installAndroidSoft } from '../../actions/anative';
import {
  // DOENLOAD_PREPARING,
  DOENLOAD_PREPARING,
  DOWNLOAD_FINISHED,
  DOWNLOAD_ING,
  INSTALL_FINISHED,
  DOWNLOAD_FAILED,
  INSTALL_FAILED,
  DOWNLOAD_CANCELED,
} from '../../constants/softstatus';
import { SIM_STATUS_RUN } from '../../constants/asimstatus';
import { setSIMPopupInfo } from '../../actions/asimstatus';
import { PCStoreJsBridge } from '../../nativeapi';
import styles from './AButton.module.less';
import { getLocalSoft } from '../../actions/native';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectDownloadSofts = createSelector(
  state => state.download,
  download => download.softs,
);
const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);
const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);
const selectSIMStatus = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.status,
);
const selectIsSIMRunning = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.issimrunnings,
);
const selectSIMDowning = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.SIMDowning,
);

export default memo(({ soft, info = {}, logInfo = {} }) => {
  const dispatch = useDispatch();
  const upgradeSofts = useSelector(selectUpgradeSofts); // 可更新
  const installedSofts = useSelector(selectInstalledSoft); // 已经安装
  const downloadSofts = useSelector(selectDownloadSofts); // 正在下载
  const logInfoData = useSelector(selectLogInfo);
  const SIMStatus = useSelector(selectSIMStatus); // 模拟器状态
  const isSIMRunning = useSelector(selectIsSIMRunning); // 电脑模拟器是否正在运行
  const SIMDowning = useSelector(selectSIMDowning);

  const [fondSoft, setFondSoft] = useState(undefined);
  const [upgrade, setUpgrade] = useState(undefined);
  const [installed, setInstalled] = useState(undefined);
  const [linearGradient, setLinearGradient] = useState(
    'linear-gradient(to right, #ffffff00 0%, #ffffff00 0%)',
  );

  const [buttonText, setButtonText] = useState(info.text || '安装');
  const installRef = useRef();
  useEffect(() => {
    installRef.current = SIMDowning;
  });
  const handleTipsModal = useCallback(softInfo => {
    PCStoreJsBridge.getIsSIMInstalled().then(SIMInstalled => {
      if (!SIMInstalled && !installRef.current) {
        dispatch(setSIMPopupInfo(softInfo));
      } else {
        dispatch(installAndroidSoft(softInfo));
      }
    });
  });

  const handleInstallSoft = useCallback(
    (soft_info, button_Text, logInfo_para) => {
      if (!soft_info.softID) {
        return;
      }
      const logParam2 = {
        source: logInfo_para.source,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        softid: soft_info.packageName,
        softName: soft_info.softName,
        packageName: soft_info.packageName,
        versionCode: soft_info.versionCode,
        softType: '1', // 安卓还是PC应用
        type: upgrade ? 'u' : 'd', // 更新还是下载
        url: soft_info.downLoadUrl || soft_info.downloadUrl,
      };
      // 档位搜索结果也跳转过来的，带上附加信息
      if (logInfo_para.isSearch) {
        logParam2.search_type = logInfoData.search_type;
        logParam2.search_word = logInfoData.search_word;
      }
      // 联想词softcard  做特殊处理 参数通过 logInfo (即logInfo_para) 传入
      if (
        logInfo_para.isSearch &&
        (logInfo_para.search_type === 4 || logInfo_para.search_type === 5)
      ) {
        logParam2.source_p = logInfo_para.source_p;
        logParam2.source_pp = logInfo_para.source_pp;
        logParam2.search_type = logInfo_para.search_type;
        logParam2.search_word = logInfo_para.search_word;
      }

      if (button_Text === info.text || button_Text === '安装' || button_Text === '升级') {
        // 按钮点击打桩
        dispatch(
          logging({
            category: 'C',
            action: 'Install',
            label: '',
            param2: logParam2,
            param3: soft_info.bizInfo || null,
          }),
        );
        const softInfo = { ...soft_info, logInfo: logParam2, isClick: 'click' };
        if (button_Text !== '安装' && button_Text !== '电脑安装') {
          dispatch(installAndroidSoft(softInfo));
        } else {
          handleTipsModal(softInfo);
        }
      } else if (button_Text === '打开') {
        // 按钮点击打桩
        logParam2.type = 'o';
        dispatch(
          logging({
            category: 'C',
            action: 'Install',
            label: '',
            param2: logParam2,
            param3: soft_info.bizInfo || null,
          }),
        );
        // 首先判断模拟器是否已经安装。
        PCStoreJsBridge.getIsSIMInstalled().then(SIMInstalled => {
          if (SIMInstalled) {
            PCStoreJsBridge.openAndroidSoft({ ...soft_info, logInfo: logParam2 });
          } else {
            // 当不存在模拟器重新获取一次本地列表改变按钮的状态。
            dispatch(getLocalSoft());
          }
        });
      }
    },
    [dispatch, upgrade],
  );

  // 查询当前是否已经安装
  useEffect(() => {
    if (upgradeSofts) {
      setUpgrade(
        upgradeSofts.find(
          soft_ =>
            (soft_.androidType !== '1' &&
              (soft_.softID === soft.softID || soft_.SoftID === soft.softID)) ||
            (soft_.androidType === '1' && soft_.packageName === soft.packageName),
        ),
      );
    }
  }, [soft, upgradeSofts]);

  // 查询当前是否已经安装 并且是否可升级
  useEffect(() => {
    if (installedSofts) {
      setInstalled(
        installedSofts.find(
          soft_ =>
            (soft_.androidType !== '1' &&
              (soft_.softID === soft.softID || soft_.SoftID === soft.softID)) ||
            (soft_.androidType === '1' && soft_.packageName === soft.packageName),
        ),
      );
    }
  }, [soft, installedSofts]);

  // 更新按钮显示状态
  useEffect(() => {
    // 按钮info传入百分比进度颜色
    const progressColor = info.progressColor || '#CAF3E1';
    // 按钮info传入百分比进度将要覆盖的背景颜色
    const backgroundColor = info.backgroundColor || '#ffffff00';
    let linear_Gradient = `linear-gradient(to right, ${progressColor} 0%, ${backgroundColor} 0%)`;
    let button_Text = info.text || '安装';
    const found = downloadSofts && downloadSofts.find(soft_ => soft_.softID === soft.softID);

    if (found && found.softID) {
      // 当按钮的状态是0 并且模拟器状态在正常运行状态列表里时  显示准备中
      if (SIM_STATUS_RUN.indexOf(SIMStatus) > -1 && found.status === DOENLOAD_PREPARING) {
        button_Text = isSIMRunning ? `0%` : '准备中';
      } else if (found.status === DOWNLOAD_ING) {
        button_Text = `${found.progress || 0}%`;
        linear_Gradient = `linear-gradient(to right, ${progressColor} ${found.progress ||
          0}%, ${backgroundColor} ${found.progress || 0}%)`;
      } else if (found.status === DOWNLOAD_FINISHED) {
        button_Text = '安装中';
        linear_Gradient = `linear-gradient(to right, ${progressColor} 100%, ${backgroundColor} 100%)`;
      } else if (found.status === INSTALL_FINISHED) {
        button_Text = '打开';
      } else if (
        found.status === DOWNLOAD_FAILED ||
        found.status === INSTALL_FAILED ||
        found.status === DOWNLOAD_CANCELED
      ) {
        // 下载安装失败时  按钮状态变为之前状态
        button_Text = upgrade ? '升级' : info.text || '安装';
      }
    } else if (upgrade) {
      button_Text = '升级';
    } else if (installed) {
      button_Text = '打开';
    }
    if (buttonText !== button_Text) setButtonText(button_Text);
    if (linearGradient !== linear_Gradient) setLinearGradient(linear_Gradient);
    setFondSoft(found);
  }, [dispatch, soft, downloadSofts, upgrade, installed, SIMStatus]);

  return (
    <>
      <div
        style={
          fondSoft && fondSoft.status && linearGradient ? { backgroundImage: linearGradient } : {}
        }
        className={
          fondSoft && fondSoft.status
            ? `${styles.soft_btn} ${styles.soft_button_busing} ${info.className_busing || ''}`
            : `${styles.soft_btn} 
            ${styles.soft_button} 
            ${info.className || ''}
            ${buttonText === '打开' && ((info && info.className_open) || styles.soft_button_open)}`
        }
        onClick={e => {
          e.preventDefault();
          // e.stopPropagation();
          handleInstallSoft(soft, buttonText, logInfo);
        }}
      >
        <span className={`${styles.soft_btn_text}`}>{buttonText}</span>
      </div>
    </>
  );
});
